@if (description()) {
    <span class="ap-input__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<ng-content select="ap-context-explanation"></ng-content>

@if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
}

<div class="ap-input__container">
    <label class="ap-input__wrapper" data-testid="wrapper">
        <span class="ap-input__label" data-testid="label">{{ label() }}</span>
        <input
            #input
            [apDate]="picker"
            class="ap-input__input"
            data-testid="input"
            [dateFilter]="dateFilter()"
            [attr.autocomplete]="autocomplete() ? autocomplete() : 'off'"
            [attr.disabled]="isDisabled ? isDisabled : null"
            [attr.type]="type()"
            [attr.maxlength]="maxlength() ? maxlength() : null"
            [attr.inputmode]="inputmode()"
            [attr.aria-required]="isRequired ? isRequired : null"
            [attr.aria-describedby]="ariaDescribedBy"
            [attr.aria-invalid]="control ? control.invalid : null"
            [min]="minDate() ? minDate() : null"
            [max]="maxDate() ? maxDate() : null"
            [attr.value]="dateValue"
            [(ngModel)]="dateValue"
            (blur)="onBlur()"
        />
        <ap-calendar-control
            #picker
            [startView]="startView()"
            [startAt]="startAt()"
            (monthSelected)="monthSelected.emit($event)"
            (yearSelected)="yearSelected.emit($event)"
        ></ap-calendar-control>
    </label>

    @if (icon()) {
        <button
            class="ap-input__button"
            cdkMonitorElementFocus
            [disabled]="isDisabled ? isDisabled : null"
            (click)="handleIconClick($event)"
            data-testid="button"
            aria-label="calendar"
        >
            <ap-icon
                [title]="label()"
                [name]="icon()"
                [size]="'large'"
                [color]="isDisabled ? 'disabled' : 'inherit'"
                data-testid="icon"
            ></ap-icon>
        </button>
    }
</div>

@if (helpTextPosition() === HelpTextPosition.BELOW && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
}

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-input__help-text {{ above ? 'ap-input__help-text--above' : 'ap-input__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="uniqueId + '-help-text'"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
